import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, PackageCheck, Search } from 'lucide-react';
import { notesApi } from '@/lib/notesApi';
import { extractError } from '@/lib/errors';

const fmt = (at) => new Date(at).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

// Super admin: who ticked "Item Received" on each main-portal piece, newest first.
export function TagReceivedLog() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState('');
  useEffect(() => { notesApi.get('/notes/tag-workspace/admin/received-log').then(({ data }) => setRows(data || [])).catch((e) => { setRows([]); toast.error(extractError(e, 'Could not load the log')); }); }, []);
  const shown = useMemo(() => {
    const s = q.trim().toLowerCase();
    return (rows || []).filter((r) => !s || `${r.jewellery_no} ${r.by_name} ${r.by}`.toLowerCase().includes(s));
  }, [rows, q]);
  if (!rows) return <div className="grid h-40 place-items-center text-muted-foreground"><Loader2 className="animate-spin" size={18} /></div>;
  return (
    <div className="space-y-3" data-testid="tagws-received-log">
      <div className="flex items-center gap-2 text-sm font-semibold text-foreground"><PackageCheck size={16} /> Item received log</div>
      <p className="text-xs text-muted-foreground">Who ticked "Item Received" on pieces that came from the main portal. The same name and time also show on each card.</p>
      <label className="relative block">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search jewellery no. or user" className="h-9 w-full rounded-lg border border-input bg-background pl-8 pr-3 text-sm" data-testid="tagws-received-log-search" />
      </label>
      {!shown.length ? <p className="text-sm text-muted-foreground" data-testid="tagws-received-log-empty">No pieces marked as received yet.</p> : (
        <div className="max-h-[55vh] overflow-y-auto rounded-xl border border-border">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-secondary text-left text-xs text-muted-foreground"><tr><th className="px-3 py-2">Jewellery no.</th><th className="px-3 py-2">Received by</th><th className="px-3 py-2">When</th></tr></thead>
            <tbody>
              {shown.map((r) => (
                <tr key={r.id} className="border-t border-border" data-testid="tagws-received-log-row">
                  <td className="px-3 py-1.5 font-mono text-xs">{r.jewellery_no}</td>
                  <td className="px-3 py-1.5">{r.by_name || r.by}<span className="block text-[length:calc(var(--fs,1)*0.6875rem)] text-muted-foreground">{r.by}{r.bulk ? ' · bulk' : ''}</span></td>
                  <td className="px-3 py-1.5 text-xs text-muted-foreground">{fmt(r.at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
